import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAlerts } from "@/lib/api";
import { positionBadge } from "@/lib/bills";
import { Users } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { useT } from "@/lib/t";

export default function ActionAlerts() {
  const { lang } = useLang();
  const t = useT();
  const [alerts, setAlerts] = useState([]);
  useEffect(() => { getAlerts({ status: "Active", lang }).then(setAlerts); }, [lang]);

  return (
    <div data-testid="action-alerts-page">
      <section className="bg-ccc-plum text-ccc-paper py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="eyebrow eyebrow-light mb-3">{t("alerts.eyebrow")}</div>
          <h1 className="font-serif text-5xl mb-4">{t("alerts.hero_title")}</h1>
          <p className="text-ccc-paper/85 max-w-2xl" style={{ fontSize: "18px", lineHeight: 1.7 }}>
            {t("alerts.hero_body")}
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 gap-6" data-testid="alerts-list">
          {alerts.map(a => (
            <Link key={a.id} to={`/take-action/action-alerts/${a.slug}`}
              data-testid={`alert-${a.slug}`}
              className="bg-white border border-ccc-rule p-8 hover:border-ccc-plum hover:shadow-sm transition-all group">
              <div className="flex items-center justify-between mb-3">
                <span className={`px-2 py-1 uppercase tracking-wider font-semibold ${positionBadge(a.position)}`} style={{ fontSize: "11px" }}>{a.position}</span>
                <div className="text-ccc-muted inline-flex items-center gap-1" style={{ fontSize: "13px" }}>
                  <Users size={12}/> {a.actions_count}
                </div>
              </div>
              <h3 className="font-serif text-2xl text-ccc-plum group-hover:text-ccc-plum-deep transition-colors leading-tight mb-3">{a.title}</h3>
              <p className="text-ccc-body leading-relaxed" style={{ fontSize: "16px" }}>{a.summary}</p>
              <div className="mt-6 text-ccc-plum uppercase font-semibold tracking-[0.14em]" style={{ fontSize: "13px" }}>
                {t("alerts.take_action_arrow")}
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
